import React from "react";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Button from "react-bootstrap/Button";
import Container from "react-bootstrap/Container";
import { ReactComponent as CenterParcs } from "../../assets/icons/CenterParcs.svg";

type EmailVerificationProps = {
  status: "loading" | "success" | "error";
  onSubmit: () => void;
  t: any;
};

const CenterParcsEmailVerification: React.FC<EmailVerificationProps> = ({
  status,
  onSubmit,
  t,
}) => {
  return (
    <div
      className="row vh-100 d-flex align-items-center justify-content-center"
      style={{ background: "#b1eda6" }}
    >
      <Container fluid>
        <Row className="justify-content-center">
          <Col xl={5} lg={6} md={7} sm={9} xs={11}>
            <div className="text-center mb-5 pb-5">
              <CenterParcs style={{ maxWidth: "450px", width: "100%" }} />
            </div>

            <div
              className="p-4 p-md-5 shadow-sm"
              style={{
                backgroundColor: "rgba(255, 255, 255, 0.15)",
                borderRadius: "20px",
              }}
            >
              <div className="d-flex flex-column">
                <h5
                  className="text-center mb-3 fw-bold"
                  style={{ color: "#045e51" }}
                >
                  {t(`emailVerification:${status}.title`)}
                </h5>
                <p className="text-center mb-3" style={{ color: "#045e51" }}>
                  {t(`emailVerification:${status}.subtitle`)}
                </p>
                <Button
                  onClick={onSubmit}
                  className="m-auto rounded-pill px-5 py-3 border-0"
                  style={{
                    backgroundColor: "#045e51",
                    color: "#b1eda6",
                    fontSize: "16px",
                    fontWeight: "bold",
                    boxShadow: "none",
                  }}
                  onFocus={(e: React.FocusEvent<HTMLButtonElement>) => {
                    e.currentTarget.style.boxShadow =
                      "0 0 0 0.2rem rgba(4, 94, 81, 0.25)";
                    e.currentTarget.style.outline = "none";
                  }}
                  onBlur={(e: React.FocusEvent<HTMLButtonElement>) => {
                    e.currentTarget.style.boxShadow = "none";
                  }}
                  onMouseEnter={(e: React.MouseEvent<HTMLButtonElement>) => {
                    e.currentTarget.style.backgroundColor = "#034a3d";
                  }}
                  onMouseLeave={(e: React.MouseEvent<HTMLButtonElement>) => {
                    e.currentTarget.style.backgroundColor = "#045e51";
                  }}
                >
                  {t("resetPassword:button.submit")}
                </Button>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default CenterParcsEmailVerification;
